import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import Anchor from "./Anchor";
import Router from "../../App/Router";

gsap.registerPlugin(ScrollTrigger);

const Submenu = {
    init() {
        this.el = $('[component="Submenu"]');
        if (!this.el.length) return;

        this.items = this.el.find('nav li');
        this.anchors = this.el.find('nav a');
        this.langSwitcher = this.el.find('[component="LangSwitcher"]');

        this.bind();
        // Anchor.init(this.el);
    },

    bind() {
        ScrollTrigger.create({
            id: 'SubmenuPin',
            trigger: this.el,
            pin: true,
            start: 'top top',
            endTrigger: $('main[component="Page"]'),
            end: "bottom bottom",
            pinSpacing: false,
            invalidateOnRefresh: true,
            onEnter: ()=> this.onEnter(),
            onLeaveBack: ()=> this.onLeaveBack(),
            // markers: true,
        });

    },

    onEnter(){
        this.langSwitcher.css({display:'flex'})
        this.el.addClass('pinned');
    },

    onLeaveBack(){
        this.langSwitcher.css({display:'none'})
        this.el.removeClass('pinned');
    },

    refresh() {
        ScrollTrigger.getById('SubmenuPin') && ScrollTrigger.getById('SubmenuPin').refresh();
    },

    select(url) {
        // console.log('Submenu.select()', url);
        if (!this.items || !this.anchors) return;

        this.items.filter('.selected').removeClass('selected');
        const anchor = this.anchors.filter('[href="/' + url + '"]');
        const selected = anchor.parent('li');
        selected.addClass('selected');
    },
}

export default Submenu